<i18n>
{
  "en": {
    "menusError": "Error loading needed data for menus"
  },
  "es": {
    "menusError": "Error cargando datos de los menús"
  }
}
</i18n>

<template>
  <router-view/>
</template>

<script>

import { createErrorNotification } from '@ulibs/unnotificationsqueue';
import Vue from 'vue';
import { MapActions } from '@core/helpers/decorators';
import { Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';

Component.registerHooks(['beforeRouteLeave']);

@Component
@MapActions(['addNotification', 'setLoading', 'momentOfConsumeListRequest', 'menuFontListRequest',
  'masterProductListRequest', 'menuSectionTypesRequest', 'templateListRequest'])
export default class Menu extends Vue {
  @Watch('$route')
  onRouteChange(to, from) {
    if (to.params.pointOfSaleGuid !== from.params.pointOfSaleGuid) this.getMenuAppData();
  }

  created() {
    this.getMenuAppData();
  }

  async getMenuAppData() {
    try {
      await this.setLoading(1);
      await Promise.all([
        this.momentOfConsumeListRequest(this.$route.params.pointOfSaleGuid),
        this.menuSectionTypesRequest(),
        this.menuFontListRequest(),
      ]);
      await this.templateListRequest();
      this.masterProductListRequest(this.$route.params.pointOfSaleGuid);
      await this.setLoading(-1);
    } catch (e) {
      this.addNotification(createErrorNotification(this.$t('menusError'), null));
    }
  }
}
</script>
